<template>
    <el-dialog
        title="Changer les valeurs des paliers"
        :visible.sync="modalOpened"
        width="50%"
        append-to-body
        class="color-modal"
    >
        <h2 class="color-modal-title">Dernière inspection entre :</h2>
        <el-row
            v-for="(item, statusName, index) in values"
            :key="statusName"
            :gutter="0"
            class="grid-row"
        >
            <el-col
                v-if="statusName === colorsConfigLastStatus"
                :span="24"
                class="limit-numbers last"
            >
                <div class="color" :style="getStyleByStatus(statusName)"></div>
                <div class="left">À partir de {{ values[statusName].min }} jours</div>
            </el-col>
            <!--  parseInt(values[colorsConfigStatuses[index-1]].max) + 1  -->
            <el-col
                v-else
                :span="24"
                class="limit-numbers"
            >
                <div class="color" :style="getStyleByStatus(statusName)"></div>
                <div v-if="statusName === colorsConfigFirstStatus" class="left">0</div>
                <div v-else class="left">{{ values[statusName].min }}</div>
                <div class="center">et</div>
                <div class="input-container">
                    <el-input
                        v-model="values[statusName].max"
                        class="max-input"
                        type="number"
                        @input="updateValue"
                    ></el-input>
                </div>
                <div>jours</div>
            </el-col>
        </el-row>
        <span slot="footer">
            <el-button @click="close">Annuler</el-button>
            <el-button type="primary" @click="saveNewConfig">Enregistrer les changements</el-button>
        </span>
    </el-dialog>
</template>

<script>

import {mapGetters} from 'vuex';

export default {

    components: {

    },

    props: {

    },

    data: function(){
        return {
            modalOpened: false,
            values: {},
            loading: false,
            baseUid: null,
        };
    },

    computed: {
        ...mapGetters([
            'basesByUid',
            'colorsConfigStatuses',
            'colorsConfig',
            'colorsConfigLastStatus',
            'colorsConfigFirstStatus',
        ]),
        selectedBase(){
            return this.basesByUid(this.baseUid);
        },
    },

    watch: {
        baseUid(val) {
            this.loadConfig();
        },
        values(){
            this.consolidateMin();
        }
    },

    mounted: function(){
        this.loadConfig();
    },

    methods: {
        consolidateMin(){
            // Consolidate min
            let previous = null;
            for(let status of this.colorsConfigStatuses){
                if(previous === null){
                   this.values[status].min = 0;
                }
                else{
                    this.values[status].min = parseInt(previous.max) + 1;
                }
                previous = this.values[status];
            }
        },
        updateValue(event){
            this.consolidateMin();
        },
        open(baseUid) {
            this.$set(this, 'baseUid', baseUid);
            this.modalOpened = true;
        },
        close() {
            this.modalOpened = false;
        },
        getStyleByStatus(status){
            return {backgroundColor: this.colorsConfig[status].color};
        },
        getDefaultValues(){
            let values = {};
            for(let status of this.colorsConfigStatuses){
                values[status] = {
                    min: this.colorsConfig[status].threshold,
                    max: this.colorsConfig[status].max,
                }
            }
            return values;
        },
        loadConfig(){
            if(this.selectedBase === undefined){
                this.$set(this, 'values', this.getDefaultValues());
                return;
            }
            let config = this.selectedBase.display_config;
            if (config === undefined || Object.keys(config).length === 0) {
                this.$set(this, 'values', this.getDefaultValues());
            } else {
                for(let status of this.colorsConfigStatuses){
                    this.$set(this.values, status, {
                        min: config[status].min || this.colorsConfig[status].min,
                        max: config[status].max || this.colorsConfig[status].max,
                    });
                }
            }
        },
        checkInput(){

            let previous = null;
            return this.colorsConfigStatuses.every(status => {
                if(previous === null){
                    if(parseInt(this.values[status].max) <= 0){
                        return false;
                    };
                }
                else{
                    if(parseInt(this.values[status].max) <= parseInt(previous.max)){
                        return false;
                    };
                }
                previous = this.values[status];
                return true;
            });
        },
        saveNewConfig() {
            if (this.checkInput()) {
                let newConfig = this.values;

                this.loading = true;

                this.$store.dispatch('patchItem', {
                    item: {
                        url: this.selectedBase.url,
                        display_config: newConfig
                    },
                    model: 'bases'
                }).then((res) => {
                    this.$store.dispatch('saveLocallyNewConfig', {
                        uid: res.uid,
                        display_config: res.display_config
                    }).then(() => {
                        this.$emit('refreshPaginate');
                        this.loading = false;
                        this.close();
                    });
                }).catch(() => {
                    this.$notify.error({
                        message: 'Erreur lors de la sauvegarde du nouveau paramétrage des couleurs'
                    });
                    this.loading = false;
                });
            } else {
                this.$notify.error({
                    message: 'Une valeur est inférieure à celle précédente'
                });
            }
        }
    },
};
</script>

<style lang="scss">
.color-modal {
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance:textfield;
    }
    .color-modal-title {
        margin: 0 0 20px;
        font-size: 20px;
    }
    .grid-row {
        height: 40px;
        margin-left: 30px;
        width: 300px;
        // background-color: red;
        .limit-numbers {
            display: flex;
            height: 100%;
            padding: 2px 10px;
            justify-content: space-between;
            align-items: center;
            .color {
                width: 50px;
                height: 20px;
                &.green {
                    background-color: #c3e7b1;
                }
                &.yellow {
                    background-color: #ffffcc;
                }
                &.orange {
                    background-color: #f6dfbc;
                }
                &.red {
                    background-color: #f9b9b9;
                }
            }
            .left {
                text-align: left;
            }
            .center {
                text-align: left;
            }
            &.last {
                justify-content: flex-start;
                .color {
                    margin-right: 20px;
                }
            }
        }
        .input-container {
            height: 100%;
            padding: 5px 10px;
            .max-input {
                height: 100%;
                width: 80px;
                input {
                    text-align: center;
                    height: 100%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/color-modal.vue